
import MainApp from './MainApp';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useNavigate
} from "react-router-dom";




function App() {
  


  return (
  
<div>
  <Router>
<MainApp />
</Router>
</div>)
}
 





 

export default App;
